import { ScanCode } from '@/utils/scan-code'
import api from '@/api'
import { useUserStore } from '@/stores/modules/user'
import { useMerchantStore } from '@/stores/modules/merchant'
import { useMerchantDeviceStore } from '@/stores/modules/merchant-device'
import { useIcCardCodeStore } from '@/stores/modules/ic-card-code'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import request from '@/utils/request'
import { asyncRoutes } from '@/router'
import { filterRoleAsyncRoutes } from '@/stores/modules/permission'

export function useIcCardLogin() {
  const userStore = useUserStore()
  const merchantStore = useMerchantStore()
  const merchantDeviceStore = useMerchantDeviceStore()
  const icCardCodeStore = useIcCardCodeStore()
  const router = useRouter()
  const route = useRoute()

  /**
   * 监听刷ic卡
   */
  function addReadIcCardCodeListener() {
    if (!icCardCodeStore.icCardCodeReader) {
      icCardCodeStore.icCardCodeReader = new ScanCode({
        success: (code) => {
          if (code) {
            icCardLogin(code)
          }
        },
        fail: (err) => {
          console.log('读取ic卡号失败', err)
        }
      })
    }
    icCardCodeStore.icCardCodeReader.addScanCodeListener()
  }

  /**
   * 取消监听刷ic卡
   */
  function removeReadIcCardCodeListener() {
    if (icCardCodeStore.icCardCodeReader) {
      icCardCodeStore.icCardCodeReader.removeScanCodeListener()
      icCardCodeStore.icCardCodeReader = null
    }
  }

  /**
   * ic卡登录
   */
  async function icCardLogin(icCardCode) {
    try {
      const { data } = await api.site.icCardLogin({
        ic_card_code: icCardCode
      })
      const { data: accountData } = await request.get('/accounts/info/mine', {
        token: data.token
      })
      const accessedRoutes = filterRoleAsyncRoutes(asyncRoutes, accountData.rolePermission)
      const firstRoute = accessedRoutes[0]?.children?.[0] // 第一个可以访问的页面
      if (!firstRoute) {
        const errorMessage =
          route.path === '/login'
            ? '登录失败，账号没有点单机相关页面权限'
            : '切换账号失败，账号没有点单机相关页面权限'
        ElMessage.error(errorMessage)
        return
      }
      userStore.logout()
      userStore.login(data)
      ElMessage.success('登录成功')
      router.replace({
        path: '/',
        query: { t: Date.now() } // 加上时间戳，否则如果当前页面是'/'，router.replace('/')不会触发router.beforeEach
      })
      if (data.merchant) {
        merchantStore.setMerchantField('id', data.merchant.id)
        merchantStore.setMerchantField('name', data.merchant.name)
      }
      merchantDeviceStore.setMerchantDevice(data.merchant_device)
    } catch (e) {
      console.error('ic卡登录失败', e)
    }
  }

  return {
    addReadIcCardCodeListener,
    removeReadIcCardCodeListener,
    icCardLogin
  }
}
